import React, { useState } from "react";
import { Box, TextField, MenuItem, Button, Typography, Select, FormControl, InputLabel } from "@mui/material";

// Dummy Device Data for Dropdown
const availableDevices = [
    { id: 1, name: "Device A" },
    { id: 2, name: "Device B" },
    { id: 3, name: "Device C" },
    { id: 4, name: "Device D" },
    { id: 5, name: "Device E" }
];

// Status Options
const STATUS_OPTIONS = ["Empty", "Work in Progress", "Finished Task"];

const CreateShipment = () => {
    const [formData, setFormData] = useState({
        containerNo: "",
        deviceNo: "",
        clientName: "",
        destination: "",
        status: ""
    });

    const [errors, setErrors] = useState({});

    // ✅ Handle Input Changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    // ✅ Form Validation
    const validateForm = () => {
        let tempErrors = {};
        if (!formData.containerNo) tempErrors.containerNo = "Container No is required";
        if (!formData.deviceNo) tempErrors.deviceNo = "Device No is required";
        if (!formData.status) tempErrors.status = "Status is required";
        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0; // ✅ Return true if no errors
    };

    // ✅ Handle Form Submission
    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return; // Stop submission if validation fails
        }

        console.log("Shipment Created:", formData);
        alert("Shipment Created Successfully!");
        setFormData({ containerNo: "", deviceNo: "", clientName: "", destination: "", status: "" }); // Reset Form
    };

    return (
        <Box sx={{ maxWidth: 500, mx: "auto", mt: 5, p: 3, boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
            <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>🚛 Create Shipment</Typography>

            <form onSubmit={handleSubmit}>
                {/* Container No */}
                <TextField
                    fullWidth required name="containerNo"
                    label="Container No" value={formData.containerNo}
                    onChange={handleChange} error={!!errors.containerNo}
                    helperText={errors.containerNo} sx={{ mb: 2 }}
                />

                {/* Device No (Dropdown) */}
                <FormControl fullWidth sx={{ mb: 2 }} error={!!errors.deviceNo}>
                    <InputLabel>Select Device</InputLabel>
                    <Select name="deviceNo" value={formData.deviceNo} onChange={handleChange}>
                        {availableDevices.map((device) => (
                            <MenuItem key={device.id} value={device.id}>{device.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Client Name (Optional) */}
                <TextField
                    fullWidth name="clientName"
                    label="Client Name (Optional)" value={formData.clientName}
                    onChange={handleChange} sx={{ mb: 2 }}
                />

                {/* Destination (Optional) */}
                <TextField
                    fullWidth name="destination"
                    label="Destination (Optional)" value={formData.destination}
                    onChange={handleChange} sx={{ mb: 2 }}
                />

                {/* Status Dropdown */}
                <FormControl fullWidth sx={{ mb: 3 }} error={!!errors.status}>
                    <InputLabel>Status</InputLabel>
                    <Select name="status" value={formData.status} onChange={handleChange}>
                        {STATUS_OPTIONS.map((status, index) => (
                            <MenuItem key={index} value={status}>{status}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {/* Submit Button */}
                <Button type="submit" fullWidth variant="contained" color="primary">Create Shipment</Button>
            </form>
        </Box>
    );
};

export default CreateShipment;
